import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    modules: [],
    modelDefault: {
        id: null,
        name: null,
        bot_id: null,
        params: null,
        login: null,
        password: null,
        user_id: null,
        hash: null,
        delimiter: null,
        message_id: null,
        notif_user_message_id: null,
        type_vk: null,
        platform: 'vk',
        method_id: null,
        priority: null,
        module_group_id: null
    },
    moduleMethods: {},
    moduleMethodsLoaded: false,
    elementsForCombobox: []
}
export default {
    state,
    getters,
    actions,
    mutations
}
